// 根据key获取标签数据
export function getIndustryNames(ids = [], dataSource = [], key = 'id', 
nodeValueKey = "industryName", childNodeKey = "childNode", noFindText = "不限") {
    // 创建一个映射，用于快速查找 ID 对应的行业名称
    const idToNameMap = new Map();
  
    // 遍历数据源，填充映射
    function traverseNodes(nodes) {
      if (!nodes) return;
      for (const node of nodes) {
        idToNameMap.set(node[key], node[nodeValueKey]);
        if (node[childNodeKey]) {
          traverseNodes(node[childNodeKey]);
        }
      }
    }
  
    // 从数据源的顶层开始遍历
    traverseNodes(dataSource, key, nodeValueKey, childNodeKey);
  
    // 根据输入的 ID 列表，生成对应的行业名称列表
    
    
    const result = ids.map(id => {
      const realId = idToNameMap.get(id);

      return realId !== null && realId !== undefined ? idToNameMap.get(id) : ''
    });
  
    return result;
  }

let timeout = null
// 函数防抖
export function debounce(func, wait = 500, immediate = false) {
	// 清除定时器
	if (timeout !== null) clearTimeout(timeout)
	// 立即执行，此类情况一般用不到
	if (immediate) {
		const callNow = !timeout
		timeout = setTimeout(() => {
			timeout = null
		}, wait)
		if (callNow) typeof func === 'function' && func()
	} else {
		// 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
		timeout = setTimeout(() => {
			typeof func === 'function' && func()
		}, wait)
	}
}